import React from 'react'
import { component_tool } from '@/tool'
const { WizSelect, WizComponent, WizRow, WizCol } = component_tool;

export default class QsSelect extends WizComponent {
    render() {
        const { options, preview, answer } = this.props
        let selectProps = {
            disabled: !preview,
            defaultValue: [null, undefined].includes(answer) ? null : parseInt(answer),
            style: { width: '100%' }
        }
        return (
            <WizRow>
                <WizCol>
                    {
                       (
                            <WizSelect {...selectProps} >
                                {options.map(val => <WizSelect.Option key={val.id} value={val.id}>{val.content}</WizSelect.Option>)}
                            </WizSelect>
                        )
                    }
                </WizCol>
            </WizRow>
        );
    }
}